import { Component, HostListener, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';
import { first } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';
import { GeneralComponent } from './general/general.component';
import { KeysComponent } from './keys/keys.component';
import { GroupComponent } from './group/group.component';
import { DeviceComponent } from './device/device.component';
import { BrowsersComponent } from './browsers/browsers.component';
import { UsersComponent } from './users/users.component';
import { AdminChatComponent } from './admin-chat/admin-chat.component';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css'],
    standalone: true,
    imports: [TranslateModule, UsersComponent, FormsModule, GeneralComponent, KeysComponent, GroupComponent, DeviceComponent, BrowsersComponent, AdminChatComponent]
})
export class SettingsComponent implements OnInit {

  Loginprivilege: any

  constructor(private loginService: LoginService) { }

  // //handle unsaved changes popup while reloading
  // @HostListener('window:beforeunload', ['$event'])
  // handleBeforeUnload(event: BeforeUnloadEvent) {
  //   event.preventDefault();
  //   event.returnValue = undefined;
  //   return;
  // }

  ngOnInit(): void {
    window.onbeforeunload=null;
    this.loginService.getUserObject().pipe(first()).subscribe((userObjResponse: any) => {
      this.Loginprivilege = userObjResponse.user.privilege
    })
  }
}
